import { render, staticRenderFns } from "./BuyRatio.vue?vue&type=template&id=3ea8e5e0&scoped=true&"
import script from "./BuyRatio.vue?vue&type=script&lang=js&"
export * from "./BuyRatio.vue?vue&type=script&lang=js&"
import style0 from "./BuyRatio.vue?vue&type=style&index=0&id=3ea8e5e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8e5e0",
  null
  
)

export default component.exports